import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlPopoverComponent } from './pl-popover.component';

@NgModule({
  declarations: [PlPopoverComponent],
  imports: [CommonModule],
  exports: [PlPopoverComponent],
})
export class PlPopoverModule {}
